import { Injectable } from '@angular/core';
import { BasedataService } from '@docma-mm-core/shared/basedata.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@docma-mm-core/config/config.service';
import { Observable } from 'rxjs';
import { FaultsData, FaultData } from './fault-data';
import { FaultDataSearch } from './fault-data';
import { map } from 'rxjs/operators';
import { Fault, LayoutFault } from './fault';
import { LoadState } from '@docma-mm-core/model/load-state/load-state';
import { LoadStatusEnum } from '@docma-mm-core/model/load-state/load-state.enum';
import { FaultCount } from './fault-counts';

@Injectable()
export class FaultLayoutApiService extends BasedataService {

  private faultDataUrl = '/data';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getFaultUrl() {
    return super.getFullUrl(this.faultDataUrl);
  }

  loadLayoutFaults(search: FaultDataSearch): Observable<LayoutFault[]> {
    const endpoint = `${this.getFaultUrl()}/search`;
    return this.http
      .post<any[]>(endpoint, search, { headers: this.getHeaders(), })
      .pipe(
        map( rs => {
          if (rs) {
            if (Array.isArray(rs)) {
              return rs.map(i => new LayoutFault({ loadState: new LoadState({data: i, status: LoadStatusEnum.Loaded})}) );
            } else {
              return (rs as any)?.Data?.map(i => new LayoutFault({ loadState: new LoadState({data: i, status: LoadStatusEnum.Loaded})}) );
            }

          } else {
            return [];
          }
        } )
      );
  }

  searchFaults(search: FaultDataSearch): Observable<{data: LayoutFault[], poolsDefectsCount: {PoolId: number, DefectsCount: number}[]}> {
    const endpoint = `${this.getFaultUrl()}/search/ids/extended`;
    return this.http
      .post<any>(endpoint, search, { headers: this.getHeaders(), })
      .pipe(
        map( result => {
          if (result) {
            if (!result.hasOwnProperty('Data')) {
              return {
                data: result.map(i =>
                  new LayoutFault({
                    id: i.Id,
                    uid: i.UniqueId,
                    isLocked: i.isLocked,
                    loadState: new LoadState({data: i, status: LoadStatusEnum.NotLoaded}),
                  })),
                poolsDefectsCount: []
              };
            } else {
              return {
                data: (result as any).Data.map(i =>
                  new LayoutFault({
                    id: i.Id,
                    uid: i.UniqueId,
                    isLocked: i.isLocked,
                    loadState: new LoadState({data: i, status: LoadStatusEnum.NotLoaded}),
                  })),
                  poolsDefectsCount: (result as any).PoolsDefectsCount
              };
            }
          } else {
            return {data: [], poolsDefectsCount: []};
          }
        })
      );
  }

  getAllFaultCount(structureId: number, layoutId: number, filterDisabled: boolean): Observable<FaultCount> {
    const endpoint = this.getFaultUrl() + '/search/count';
    const body = {
      Structure: structureId,
      LayoutId: layoutId,
      OnlyDefectId: true,
      IsLayoutFilterDisabled: true
    };

    return this.http
      .post<FaultCount>(endpoint, JSON.stringify(body),  { headers: this.getHeaders() });
  }
}

